import { useRouter } from 'next/router';

import { useCallback } from 'react';

import { useQuery } from '@apollo/client';

import { useCommunityContext } from 'components/CommunityContext';

import { USERS_QUERY } from 'schema/User/queries';

import { Mention, mapUserObject } from './helpers';

export const useUsersSearch = (): {
  handleSearch: (search: string, spaceId?: string) => Promise<Mention[]>;
} => {
  const { community } = useCommunityContext();
  const router = useRouter();

  const spaceId = router?.query?.spaceId as string | undefined;

  // FetchMore setup (can be extracted if needed elsewhere too)
  const { fetchMore } = useQuery(USERS_QUERY, {
    variables: {
      communityId: community.id,
      ...(spaceId && { spaceId }),
    },
    notifyOnNetworkStatusChange: true,
    skip: true, // only call via fetchMore manually
  });

  const handleSearch = useCallback(
    async (search: string, overrideSpaceId?: string) => {
      const spaceIdToUse = overrideSpaceId || router?.query?.spaceId;
      const variables = {
        searchTerm: search,
        communityId: community.id,
        ...(spaceIdToUse && { spaceId: spaceIdToUse }),
      };

      const res = await fetchMore({ variables });
      return mapUserObject(res?.data?.community?.mentionableUsers?.edges);
    },
    [community.id, fetchMore, router?.query?.spaceId]
  );

  return { handleSearch };
};
